import React from 'react';
import styled from 'styled-components';
import { useMatches } from 'react-router-dom';

import { COOKIES_KEY } from '../cookies';
import { DataElementContext } from '../../../page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import ExpiringLocalStorage from '@/modules/casino/utils/ExpiringLocalStorage';
import { useMediaQuery } from '@/components/utils/useQueryMedia';

//import './index.scss';

type ChampionShipPopupProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const ChampionShipPopup = (componentProps: ChampionShipPopupProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  [props] = processComponentProps(props, dataElementContext);
  const uriMatches = useMatches();
  const isDesktop = useMediaQuery('(min-width:900px)');

  const isPopupEnabled = window.config.championshipEnabled === '1' && window.config.championshipTutorialEnabled === '1';
  const currentYear = new Date().getFullYear();

  const [state, setState] = React.useState({
    shown: localStorage.getItem(`cps_${currentYear}`) === 'true' ? true : false,
    showPopup: false,
  });

  React.useEffect(() => {
    if (isPopupEnabled) {
      document.body.classList.remove('championship-popup-open');
      const cookies = ExpiringLocalStorage.get(COOKIES_KEY);

      let pathName = '/';

      if (uriMatches && uriMatches.length) {
        const uriMatch = uriMatches[uriMatches.length - 1];
        pathName = uriMatch.pathname;
      }

      if (!isDesktop && pathName === '/' && cookies && localStorage.getItem(`cps_${currentYear}`) !== 'true') {
        setTimeout(() => {
          setState((v) => ({ ...v, shown: false, showPopup: true }));
          document.body.classList.add('championship-popup-open');
        }, 1000);
      } else if (pathName !== '/' || isDesktop) {
        setState((v) => {
          if (v.showPopup) {
            localStorage.setItem(`cps_${currentYear}`, 'true');
            return { ...v, shown: true, showPopup: false };
          }
          return { ...v, showPopup: false };
        });
      }
    }
  }, [uriMatches, isDesktop, isPopupEnabled, currentYear]);

  const onHidePopup = React.useCallback(() => {
    setState((v) => ({ ...v, showPopup: false }));
    localStorage.setItem(`cps_${currentYear}`, 'true');
    document.body.classList.remove('championship-popup-open');
  }, [currentYear]);

  const contextValue = React.useMemo(() => {
    return {
      ...state,
      onHidePopup,
    };
  }, [state, onHidePopup]);

  if (!isPopupEnabled) return null;
  if (state.shown) return null;

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default ChampionShipPopup;
